var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFillIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02735 4.51613C6.27445 4.51613 7.28542 3.50516 7.28542 2.25806C7.28542 1.01097 6.27445 0 5.02735 0C3.78026 0 2.76929 1.01097 2.76929 2.25806C2.76929 3.50516 3.78026 4.51613 5.02735 4.51613Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02731 5.16132C2.8972 5.16132 1.08896 6.53766 0.442719 8.44913C0.194332 9.18318 0.711178 9.96813 1.48537 9.99895C1.50329 9.99967 1.52157 10 1.53985 10H8.5144C8.53268 10 8.55096 9.99967 8.56888 9.99895C9.34344 9.96813 9.85992 9.18354 9.61154 8.44913C8.9653 6.5373 7.15706 5.16132 5.02695 5.16132H5.02731Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFillIcon);
export default __webpack_public_path__ + "static/media/UserFillIcon.c4ff9cbe3bd63cfe39b28ebc83bb2767.svg";
export { ForwardRef as ReactComponent };